import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';
import productService from 'v2/services/product';

type Payload = {
  productId: number;
  email: string;
};

export function useProductInviteAffiliate(options: UseMutationOptions<any, unknown, Payload> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ productId, email }: Payload) => productService.inviteAffiliate(productId, email),
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['product'] });
      options.onSuccess?.(...args);
    }
  });
}
